import { Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { EventPollAnswer, EventPollQuestion } from '../../../../../interfaces/interfaces';
import { MBWPollLinearProgress } from './MBWPollLinearProgress';
import usePoll from '../../../../../hooks/usePoll';

interface MBWPollStatsProps {
  poll: EventPollQuestion;
  pollAnswer?: EventPollAnswer;
  type: 'question' | 'answer';
  isLoadingOptionActive: boolean;
}

export interface EventPollQuestionStats {
  _id: string;
  answeredPolls: number;
}

export interface EventPollAnswerStats {
  _id: string;
  answers: any[];
}

export const MBWPollStats = (props: MBWPollStatsProps) => {
  const { poll, pollAnswer, type, isLoadingOptionActive } = props;
  const [isLoading] = useState<boolean>(false);
  const { t } = useTranslation('analytics');
  const { sumVotes } = usePoll();

  return (
    <>
      {(poll?.isAnswered || true) && (
        <div className="w-full">
          {isLoading && isLoadingOptionActive && (
            <div className="text-center px-4">
              <Skeleton animation="wave" height={10} width="100%" style={{ marginBottom: 6 }} />
            </div>
          )}
          {!isLoading && (
            <div className="w-full">
              {type === 'question' && <p style={{ fontSize: '12px', padding: '10px' }}>{t('poll:total-answers', { count: sumVotes(poll) })}</p>}
              {type === 'answer' && (
                <div className="flex flex-col w-full">
                  <MBWPollLinearProgress value={pollAnswer?.percentage!} />
                  <Typography variant="caption" component="div" color="textSecondary">{`${pollAnswer?.percentage}%`}</Typography>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};
